import { useLegacyCard } from '@/src/common/hooks/useCardInformation'
import { useReferralShareSheetMessageParameterStore } from '@/src/services/Statsig/useReferralShareSheetMessageParameterStore'

export function useReferralShareMessage(referralCode: string) {
  const referralStore = useReferralShareSheetMessageParameterStore()
  const { data } = useLegacyCard()

  const shareSheetURL = new URL(
    referralStore.get('share_sheet_link', 'https://mesamember.com/card'),
  )
  shareSheetURL.searchParams.set('referral_code', referralCode)
  const shareSheetLink = shareSheetURL.toString()

  const referralShareSheetMessage = referralStore.get(
    'share_sheet_message',
    'Just got the Mesa Homeowners Card - no annual fee, earns points on my mortgage and comes with $800+ in home benefits! We both get bonus points if you get approved and spend. Use my code to apply: [CODE] Terms apply.',
  )

  const referralShareSheetMessageNonCardholder = referralStore.get(
    'share_sheet_message_non_cardholder',
    'Check out the Mesa Homeowners Card - no annual fee, earns points on your mortgage and comes with $800+ in home benefits! We both get bonus points if you get approved and spend. Use my code to apply: [CODE] Terms apply.',
  )

  const shareMessageTemplate = data?.getCreditCardInformation.node
    ? referralShareSheetMessage
    : referralShareSheetMessageNonCardholder

  const shareMessageWithCode = shareMessageTemplate.replace('[CODE]', referralCode)
  return { shareSheetLink, shareMessageTemplate, shareMessageWithCode }
}
